Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = void 0;
function getEventEmitter(name = '') {
    const cacheKey = `henderson-event-emitter_${name}`;
    let eventEmitter = window[cacheKey];
    if (!eventEmitter) {
        window[cacheKey] = new EventEmitter();
        eventEmitter = window[cacheKey];
    }
    return eventEmitter;
}
exports.default = getEventEmitter;
class EventEmitter {
    constructor() {
        this.events = {};
    }
    emit(eventName, ...data) {
        setTimeout(() => {
            const event = this.events[eventName];
            if (event) {
                event.forEach(fn => {
                    if (data && data.length > 0) {
                        fn.call(null, ...data);
                    }
                    else {
                        fn();
                    }
                });
            }
        }, 1);
    }
    subscribe(eventName, fn) {
        if (!this.events[eventName]) {
            this.events[eventName] = [];
        }
        this.events[eventName].push(fn);
        return () => {
            this.events[eventName] = this.events[eventName].filter(eventFn => fn !== eventFn);
        };
    }
}
exports.EventEmitter = EventEmitter;
//# sourceMappingURL=getEventEmitter.js.map